module.exports = __webpack_public_path__ + "media/images/payments/paypal-dark-f0d7db0281b36a76685ef91597a8f709.svg";